import {HttpErrorResponse} from '@angular/common/http';
import {createAction, props} from '@ngrx/store';
import {IGetRolesResponse} from '../../main/pages/users/roles/roles.service';
import * as StoreKeys from './../store-key.config';

const scope =`[${StoreKeys.auth_key}]`;

export const addTemplateRole = createAction(`${scope} Add Template`, props<{roles}>());
export const resetState = createAction(`${scope} Reset State`);
export const fetchRolesList = createAction(`${scope} Fetch Roles List`);
export const fetchRolesListSucceed = createAction(`${scope} Fetch Roles List Succeed`, props<{roles:IGetRolesResponse[]}>());
export const fetchRolesListFailed = createAction(`${scope} Fetch Roles List Failed`, props<{error:HttpErrorResponse}>());
